export const faqItems = [
  {
    question: "Soru 1",
    answer: "Açıklama",
  },
  {
    question: "Soru 2",
    answer: "Açıklama",
  },
  {
    question: "Soru 3",
    answer: "Açıklama",
  },
  {
    question: "Soru 4",
    answer: "Açıklama",
  },
];
